module.exports = __webpack_public_path__ + "img/bookmark.5c367b3e.svg";